import './style/index.js';

import _ChatSender from './chat-sender.jsx';

export const ChatSender = _ChatSender;
export default ChatSender;

export * from './type';
